export default {
  group: {
    searchPlaceholder: '物料分类编码/物料分类名称',
    groupNo: '分类编码',
    groupName: '分类名称',
    status: '状态',
    remarks: '备注',
    addByName: '创建人员',
    adddate: '创建时间',
    updateByName: '更改人员',
    upddate: '更改时间'
  },
  goods: {
    searchPlaceholder: '料号/品名',
    groupNo: '物料分类',
    goodsNo: '料号',
    goodsName: '品名',
    goodsType: '物料类型',
    spec: '规格',
    unitNo: '单位',
    weight: '重量',
    goodsAlias: '物料别名',
    goodsNameEn: '英文名称',
    len: '长/M',
    width: '宽/M',
    high: '高/M',
    vol: '体积/M3',
    productTime: '有效期/天',
    goodsPrice: '价格/￥',
    barRuleNo: '条码规则',
    packQty: '单包数量',
    checkFlag: '是否检验',
    mostLot: '单次送货最多批次',
    snFlag: '是否管理SN',
    goodsRate: '税率',
    passProportion: '最大超交率'
  }
}
